import { ExerciseState } from "@tt-app/types";

const initialState = (): ExerciseState => ({
  accuracy: undefined,
  actual: undefined,
  answers: {},
  currentPageIndex: 0,
  details: undefined,
  inProgress: false,
  limitedModeUpdated: false,
  loading: 0,
  logId: undefined,
  modals: {
    navigation: {
      next: undefined,
      open: false
    }
  },
  processing: 0,
  results: undefined,
  settings: {
    modal: {
      open: false
    },
    hints: false
  }
});

const exerciseState = initialState();

export { exerciseState };
